import React from 'react';

import ProfileAlbumsFunc from './component';

export default React.memo(ProfileAlbumsFunc);
